"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForwardLink = exports.BackLink = exports.ConditionalRoute = exports.AuthenticatedRoute = exports.RouteWithProps = exports.CurrentRoute = exports.Debug = exports.StaticRouter = exports.BrowserRouter = exports.history = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _history = require("history");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var history = canUseDOM ? (0, _history.createBrowserHistory)() : (0, _history.createMemoryHistory)();
exports.history = history;

var BrowserRouter =
/*#__PURE__*/
function (_OriginalBrowserRoute) {
  _inherits(BrowserRouter, _OriginalBrowserRoute);

  function BrowserRouter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BrowserRouter)).call.apply(_getPrototypeOf2, [this].concat(args)));
    var props = args[0];
    _this.history = props.history || history;
    return _this;
  }

  return BrowserRouter;
}(_reactRouterDom.BrowserRouter);

exports.BrowserRouter = BrowserRouter;

var StaticRouter =
/*#__PURE__*/
function (_OriginalStaticRouter) {
  _inherits(StaticRouter, _OriginalStaticRouter);

  function StaticRouter() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, StaticRouter);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(StaticRouter)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this2.history = history;
    return _this2;
  }

  return StaticRouter;
}(_reactRouterDom.StaticRouter);

exports.StaticRouter = StaticRouter;

var DebugComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DebugComponent, _React$PureComponent);

  function DebugComponent() {
    _classCallCheck(this, DebugComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DebugComponent).apply(this, arguments));
  }

  _createClass(DebugComponent, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.log('Route:', this.props.location.pathname, this.props);
      }

      return null;
    }
  }]);

  return DebugComponent;
}(_react["default"].PureComponent);

var Debug = (0, _reactRouterDom.withRouter)(DebugComponent);
exports.Debug = Debug;
var CurrentRoute = (0, _reactRouterDom.withRouter)(function (props) {
  return props.location.pathname;
});
exports.CurrentRoute = CurrentRoute;

var RouteWithProps = function RouteWithProps(_ref) {
  var path = _ref.path,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      sensitive = _ref.sensitive,
      Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ["path", "exact", "strict", "location", "sensitive", "component"]);

  return _react["default"].createElement(_reactRouterDom.Route, {
    path: path,
    exact: exact,
    strict: strict,
    location: location,
    sensitive: sensitive,
    render: function render(props) {
      return _react["default"].createElement(Component, _extends({}, props, rest));
    }
  });
};

exports.RouteWithProps = RouteWithProps;

var AuthenticatedRoute = function AuthenticatedRoute(_ref2) {
  var isAuthenticated = _ref2.isAuthenticated,
      redirectTo = _ref2.redirectTo,
      Component = _ref2.component,
      _ref2$loginPath = _ref2.loginPath,
      loginPath = _ref2$loginPath === void 0 ? '/login' : _ref2$loginPath,
      redirectFromLoginTo = _ref2.redirectFromLoginTo,
      rest = _objectWithoutProperties(_ref2, ["isAuthenticated", "redirectTo", "component", "loginPath", "redirectFromLoginTo"]);

  var children = rest.children || null;
  var path = rest.path,
      exact = rest.exact;

  if (!isAuthenticated) {
    var redirect = function redirect(to) {
      return (0, _reactRouterDom.matchPath)(to, {
        path: path,
        exact: exact
      }) ? children : _react["default"].createElement(_reactRouterDom.Redirect, {
        to: to
      });
    };

    return redirect(loginPath);
  }

  if (redirectFromLoginTo && history.location.pathname === loginPath) {
    return _react["default"].createElement(_reactRouterDom.Redirect, {
      to: redirectFromLoginTo
    });
  }

  if (redirectTo) {
    return _react["default"].createElement(_reactRouterDom.Redirect, {
      to: redirectTo
    });
  }

  return _react["default"].createElement(_react["default"].Fragment, null, children, Component && _react["default"].createElement(RouteWithProps, _extends({
    component: Component
  }, rest)));
};

exports.AuthenticatedRoute = AuthenticatedRoute;
AuthenticatedRoute.propTypes = _objectSpread({}, _reactRouterDom.Route.PropTypes, {
  isAuthenticated: _propTypes["default"].bool.isRequired,
  redirectTo: _propTypes["default"].string,
  component: _propTypes["default"].func,
  loginPath: _propTypes["default"].string,
  children: _propTypes["default"].node
});

var ConditionalRoute = function ConditionalRoute(_ref3) {
  var conditional = _ref3.conditional,
      True = _ref3.trueComponent,
      False = _ref3.falseComponent,
      trueRedirectTo = _ref3.trueRedirectTo,
      falseRedirectTo = _ref3.falseRedirectTo,
      rest = _objectWithoutProperties(_ref3, ["conditional", "trueComponent", "falseComponent", "trueRedirectTo", "falseRedirectTo"]);

  if (conditional) {
    return True ? _react["default"].createElement(_reactRouterDom.Route, _extends({
      render: function render(props) {
        return _react["default"].createElement(True, props);
      }
    }, rest)) : _react["default"].createElement(_reactRouterDom.Route, _extends({
      render: function render() {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: trueRedirectTo
        });
      }
    }, rest));
  }

  return False ? _react["default"].createElement(_reactRouterDom.Route, _extends({
    render: function render(props) {
      return _react["default"].createElement(False, props);
    }
  }, rest)) : _react["default"].createElement(_reactRouterDom.Route, _extends({
    render: function render() {
      return _react["default"].createElement(_reactRouterDom.Redirect, {
        to: falseRedirectTo
      });
    }
  }, rest));
};

exports.ConditionalRoute = ConditionalRoute;
var BackLink = (0, _reactRouterDom.withRouter)(function (_ref4) {
  var history = _ref4.history,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["history", "children"]);

  var navigate = function navigate(event) {
    event.preventDefault();
    history.goBack();
  };

  return _react["default"].createElement(_reactRouterDom.Link, _extends({
    to: "",
    onClick: navigate
  }, rest), children);
});
exports.BackLink = BackLink;
var ForwardLink = (0, _reactRouterDom.withRouter)(function (_ref5) {
  var history = _ref5.history,
      children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["history", "children"]);

  var navigate = function navigate(event) {
    event.preventDefault();
    history.goForward();
  };

  return _react["default"].createElement(_reactRouterDom.Link, _extends({
    to: "",
    onClick: navigate
  }, rest), children);
});
exports.ForwardLink = ForwardLink;